import { WidokiMapy } from "./mapa-widok.reducer";

export const WIDOKI_MAPY_ID = {
  WIDOK_MAPY: 'WIDOK_MAPY',
  WIDOK_PASKA_CZASU: 'WIDOK_PASKA_CZASU',
  PRZEJDZ_DO_WSPOLRZEDNYCH: 'PRZEJDZ_DO_WSPOLRZEDNYCH',
  WIDOK_POROWNANIE: 'WIDOK_POROWNANIE',
  WIDOK_NARZEDZIA: 'WIDOK_NARZEDZIA',
  ZMIERZ_NA_MAPIE: 'ZMIERZ_NA_MAPIE',
  SZLAK: 'SZLAK'
};


const WIDOKI_MAPY_WIDOK_MAPY = {
  id: WIDOKI_MAPY_ID.WIDOK_MAPY, desktop: true, mobile: true
} as WidokiMapy;
const WIDOKI_MAPY_WIDOK_PASKA_CZASU = {
  id: WIDOKI_MAPY_ID.WIDOK_PASKA_CZASU,
  desktop: true,
  mobile: true
} as WidokiMapy;
const WIDOK_POROWNANIE = {
  id: WIDOKI_MAPY_ID.WIDOK_POROWNANIE,
  desktop: true,
  mobile: false
} as WidokiMapy;

const WIDOK_PRZEJDZ_DO_WSPOLRZEDNYCH = {
  id: WIDOKI_MAPY_ID.PRZEJDZ_DO_WSPOLRZEDNYCH, desktop: true, mobile: true
} as WidokiMapy;

const WIDOK_ZMIERZ_NA_MAPIE = {
  id: WIDOKI_MAPY_ID.ZMIERZ_NA_MAPIE, desktop: true, mobile: true
} as WidokiMapy;

const SZLAK = {
  id: WIDOKI_MAPY_ID.SZLAK, desktop: true, mobile: true
} as WidokiMapy;
export const DEFINICJA_WIDOKOW_MAPY = new Map<string, WidokiMapy>([
  [WIDOKI_MAPY_ID.WIDOK_MAPY, WIDOKI_MAPY_WIDOK_MAPY],
  [WIDOKI_MAPY_ID.WIDOK_PASKA_CZASU, WIDOKI_MAPY_WIDOK_PASKA_CZASU],
  [WIDOKI_MAPY_ID.WIDOK_POROWNANIE, WIDOK_POROWNANIE],
  [WIDOKI_MAPY_ID.PRZEJDZ_DO_WSPOLRZEDNYCH, WIDOK_PRZEJDZ_DO_WSPOLRZEDNYCH],
  [WIDOKI_MAPY_ID.ZMIERZ_NA_MAPIE, WIDOK_ZMIERZ_NA_MAPIE],
  [WIDOKI_MAPY_ID.SZLAK, SZLAK],
]);
